import styled from "styled-components";

export const DataTable = styled.div`
  background: white;
  border-radius: 1rem;
  border: 2px solid #e9ecef;
`;

export const TableHeader = styled.div`
  background: #f8f9fa;
  padding: 0.75rem 1rem;
  font-weight: 600;
  border-bottom: 2px solid #e9ecef;
  display: grid;
  grid-template-columns: ${(props) => props.columns || "1fr 1fr 1fr 1fr"};
  gap: 1rem;
  border-top-left-radius: calc(1rem - 2px);
  border-top-right-radius: calc(1rem - 2px);
`;

export const TableRow = styled.div`
  padding: 0.75rem 1rem;
  border-bottom: 0.125rem solid #e9ecef;
  display: grid;
  grid-template-columns: ${(props) => props.columns || "1fr 1fr 1fr 1fr"};
  gap: 1rem;
  align-items: center;

  &:first-child {
    border-top-left-radius: calc(1rem - 2px);
    border-top-right-radius: calc(1rem - 2px);
  }

  &:last-child {
    border-bottom: none;
    border-bottom-left-radius: calc(1rem - 2px);
    border-bottom-right-radius: calc(1rem - 2px);
  }

  &:hover {
    background: #f8f9fa;
  }

  &:active {
    background: #e9ecef;
  }
`;

export const TableCell = styled.div`
  font-size: 1rem;
`;

export const TableCellBold = styled(TableCell)`
  font-weight: 600;
`;
